// In development: http://localhost:8000/api
// In production: /api (relative path, same domain)
export const API_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000/api');
